import React from "react";
import singleSpaReact from "single-spa-react";
import ReactDOM from "react-dom";
import { UserClaims } from "@okta/okta-auth-js";
import { User } from "./types/users";

export interface OneProfileSetupConfig {
  activationFn?: (
    accessToken: string,
    currentUser: UserClaims & User
  ) => Promise<boolean>;
}

export default function oneProfileSetup(
  rootComponent: React.FunctionComponent<any>,
  config?: OneProfileSetupConfig
) {
  const { bootstrap, mount, unmount, update } = singleSpaReact({
    React,
    ReactDOM,
    rootComponent: rootComponent,
    errorBoundary(err, info, props) {
      // Customize the root error boundary for your microfrontend here.
      return null;
    },
  });
  return { bootstrap, mount, unmount, update, config };
}
